var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServMob4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 158,
    viewBox: "0 0 343 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_75)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 158,
    rx: 8,
    fill: "#EB7565"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.913,
    cy: 40,
    r: 14,
    stroke: "#FFF7F0",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.913,
    y: 24,
    width: 32,
    height: 32,
    fill: "#755CDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.913,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.913,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.913,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.913,
    y: 70,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.913,
    y: 70,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.913,
    y: 70,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.913,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.913,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.913,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.913 56L287.913 88V56H255.913Z",
    fill: "#F39E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.913,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.913,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.913,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.913,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.913,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.913,
    y: 80,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.913,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.913,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.913,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.913,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.913,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.913,
    y: 24,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.913,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.913,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.913,
    y: 28,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.913,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.913,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.913,
    y: 52,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.913 56L223.913 88V56H191.913Z",
    fill: "#61C4B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.913 24L191.913 56V24H223.913Z",
    fill: "#FFF7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0776 129H29.3416V111.12H26.0776V129ZM32.5167 129H35.6607V110.832H32.5167V129ZM38.5636 129H41.7076V110.832H38.5636V129ZM49.2665 129.288C50.0825 129.288 50.8025 129.136 51.4265 128.832C52.0665 128.512 52.5705 128.048 52.9385 127.44V129H55.9145V115.944H52.7705V123.6C52.7705 124.464 52.5225 125.152 52.0265 125.664C51.5305 126.16 50.8985 126.408 50.1305 126.408C49.3465 126.408 48.7065 126.16 48.2105 125.664C47.7305 125.168 47.4905 124.504 47.4905 123.672V115.944H44.3465V123.936C44.3465 125.536 44.7785 126.832 45.6425 127.824C46.5225 128.8 47.7305 129.288 49.2665 129.288ZM63.805 129.288C64.797 129.288 65.661 129.12 66.397 128.784C67.133 128.448 67.709 127.984 68.125 127.392C68.541 126.784 68.749 126.088 68.749 125.304C68.749 124.392 68.461 123.608 67.885 122.952C67.309 122.296 66.477 121.816 65.389 121.512L63.301 120.888C62.853 120.76 62.485 120.592 62.197 120.384C61.909 120.176 61.765 119.888 61.765 119.52C61.765 119.136 61.917 118.824 62.221 118.584C62.525 118.344 62.941 118.224 63.469 118.224C64.125 118.224 64.717 118.4 65.245 118.752C65.789 119.104 66.165 119.576 66.373 120.168L68.773 119.04C68.373 117.984 67.701 117.16 66.757 116.568C65.813 115.96 64.725 115.656 63.493 115.656C62.549 115.656 61.709 115.824 60.973 116.16C60.253 116.496 59.685 116.968 59.269 117.576C58.869 118.168 58.669 118.864 58.669 119.664C58.669 120.56 58.949 121.336 59.509 121.992C60.085 122.648 60.925 123.136 62.029 123.456L64.165 124.056C64.581 124.168 64.933 124.336 65.221 124.56C65.525 124.768 65.677 125.056 65.677 125.424C65.677 125.856 65.501 126.2 65.149 126.456C64.813 126.696 64.365 126.816 63.805 126.816C63.069 126.816 62.405 126.608 61.813 126.192C61.221 125.776 60.749 125.2 60.397 124.464L58.045 125.592C58.429 126.712 59.133 127.608 60.157 128.28C61.197 128.952 62.413 129.288 63.805 129.288ZM77.1172 129.144C77.6452 129.144 78.1652 129.104 78.6772 129.024V126.312C78.3732 126.36 78.0932 126.384 77.8372 126.384C77.0692 126.384 76.5092 126.208 76.1572 125.856C75.8052 125.504 75.6292 125 75.6292 124.344V118.752H78.6292V115.944H75.6292V112.968H72.4852V113.976C72.4852 114.616 72.3092 115.104 71.9572 115.44C71.6052 115.776 71.1092 115.944 70.4692 115.944H70.2292V118.752H72.4852V124.512C72.4852 125.968 72.8852 127.104 73.6852 127.92C74.5012 128.736 75.6452 129.144 77.1172 129.144ZM81.0792 129H84.2232V121.728C84.2232 120.736 84.4952 119.968 85.0392 119.424C85.5992 118.864 86.3192 118.584 87.1992 118.584H88.3272V115.8H87.5592C86.7592 115.8 86.0552 115.944 85.4472 116.232C84.8392 116.52 84.3672 117.04 84.0312 117.792V115.944H81.0792V129ZM94.0158 129.288C95.7118 129.288 97.0718 128.728 98.0958 127.608V129H101.072V120.312C101.072 119.4 100.84 118.592 100.376 117.888C99.9118 117.184 99.2718 116.64 98.4558 116.256C97.6558 115.856 96.7198 115.656 95.6478 115.656C94.3358 115.656 93.1678 115.968 92.1438 116.592C91.1198 117.216 90.4158 118.04 90.0318 119.064L92.5998 120.312C92.8398 119.72 93.2158 119.248 93.7278 118.896C94.2398 118.528 94.8398 118.344 95.5278 118.344C96.2478 118.344 96.8238 118.536 97.2558 118.92C97.7038 119.288 97.9278 119.752 97.9278 120.312V120.744L94.0398 121.368C92.5038 121.624 91.3678 122.112 90.6318 122.832C89.8958 123.552 89.5278 124.456 89.5278 125.544C89.5278 126.696 89.9358 127.608 90.7518 128.28C91.5678 128.952 92.6558 129.288 94.0158 129.288ZM92.7918 125.424C92.7918 124.512 93.4078 123.936 94.6398 123.696L97.9278 123.144V123.672C97.9278 124.568 97.6158 125.328 96.9918 125.952C96.3838 126.576 95.5838 126.888 94.5918 126.888C94.0638 126.888 93.6318 126.76 93.2958 126.504C92.9598 126.232 92.7918 125.872 92.7918 125.424ZM109.695 129.144C110.223 129.144 110.743 129.104 111.255 129.024V126.312C110.951 126.36 110.671 126.384 110.415 126.384C109.647 126.384 109.087 126.208 108.735 125.856C108.383 125.504 108.207 125 108.207 124.344V118.752H111.207V115.944H108.207V112.968H105.063V113.976C105.063 114.616 104.887 115.104 104.535 115.44C104.183 115.776 103.687 115.944 103.047 115.944H102.807V118.752H105.063V124.512C105.063 125.968 105.463 127.104 106.263 127.92C107.079 128.736 108.223 129.144 109.695 129.144ZM113.657 114.48H116.801V111.12H113.657V114.48ZM113.657 129H116.801V115.944H113.657V129ZM126.088 129.288C127.352 129.288 128.504 129 129.544 128.424C130.584 127.832 131.416 127.024 132.04 126C132.664 124.96 132.976 123.784 132.976 122.472C132.976 121.16 132.664 119.992 132.04 118.968C131.432 117.944 130.608 117.136 129.568 116.544C128.528 115.952 127.368 115.656 126.088 115.656C124.792 115.656 123.624 115.952 122.584 116.544C121.544 117.136 120.712 117.944 120.088 118.968C119.48 119.992 119.176 121.16 119.176 122.472C119.176 123.784 119.48 124.952 120.088 125.976C120.712 127 121.544 127.808 122.584 128.4C123.64 128.992 124.808 129.288 126.088 129.288ZM126.088 126.408C125.384 126.408 124.752 126.24 124.192 125.904C123.648 125.568 123.216 125.104 122.896 124.512C122.592 123.904 122.44 123.224 122.44 122.472C122.44 121.72 122.592 121.048 122.896 120.456C123.216 119.864 123.648 119.4 124.192 119.064C124.752 118.712 125.384 118.536 126.088 118.536C126.792 118.536 127.408 118.712 127.936 119.064C128.48 119.4 128.904 119.864 129.208 120.456C129.528 121.048 129.688 121.72 129.688 122.472C129.688 123.224 129.528 123.904 129.208 124.512C128.904 125.104 128.48 125.568 127.936 125.904C127.408 126.24 126.792 126.408 126.088 126.408ZM135.36 129H138.504V121.344C138.504 120.496 138.744 119.816 139.224 119.304C139.72 118.792 140.36 118.536 141.144 118.536C141.928 118.536 142.56 118.792 143.04 119.304C143.536 119.8 143.784 120.48 143.784 121.344V129H146.928V120.6C146.928 119.624 146.72 118.768 146.304 118.032C145.888 117.28 145.304 116.696 144.552 116.28C143.816 115.864 142.968 115.656 142.008 115.656C141.192 115.656 140.456 115.816 139.8 116.136C139.16 116.456 138.664 116.928 138.312 117.552V115.944H135.36V129ZM154.555 129.288C155.547 129.288 156.411 129.12 157.147 128.784C157.883 128.448 158.459 127.984 158.875 127.392C159.291 126.784 159.499 126.088 159.499 125.304C159.499 124.392 159.211 123.608 158.635 122.952C158.059 122.296 157.227 121.816 156.139 121.512L154.051 120.888C153.603 120.76 153.235 120.592 152.947 120.384C152.659 120.176 152.515 119.888 152.515 119.52C152.515 119.136 152.667 118.824 152.971 118.584C153.275 118.344 153.691 118.224 154.219 118.224C154.875 118.224 155.467 118.4 155.995 118.752C156.539 119.104 156.915 119.576 157.123 120.168L159.523 119.04C159.123 117.984 158.451 117.16 157.507 116.568C156.563 115.96 155.475 115.656 154.243 115.656C153.299 115.656 152.459 115.824 151.723 116.16C151.003 116.496 150.435 116.968 150.019 117.576C149.619 118.168 149.419 118.864 149.419 119.664C149.419 120.56 149.699 121.336 150.259 121.992C150.835 122.648 151.675 123.136 152.779 123.456L154.915 124.056C155.331 124.168 155.683 124.336 155.971 124.56C156.275 124.768 156.427 125.056 156.427 125.424C156.427 125.856 156.251 126.2 155.899 126.456C155.563 126.696 155.115 126.816 154.555 126.816C153.819 126.816 153.155 126.608 152.563 126.192C151.971 125.776 151.499 125.2 151.147 124.464L148.795 125.592C149.179 126.712 149.883 127.608 150.907 128.28C151.947 128.952 153.163 129.288 154.555 129.288Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 158,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServMob4);
export default __webpack_public_path__ + "static/media/serv_mob4.e22e2c336c400665f1528dd9b5240a9b.svg";
export { ForwardRef as ReactComponent };